import { StorageKey } from '@medrecord/tools-storage';

export const provideStorageKey = () => (
  {
    provide: StorageKey,
    useValue: 'medrecord_coaching',
  }
);
